import { useEffect, useRef } from "react";
import "./index.scss";
import ChromaKeyVideo from "../ChromaKeyVideo";

const Avatar = ({
  canvasElementShow,
  videoElementShow,
  textExpressionElementShow,
  videoURL,
  talkUrl,
  idleURL,
  origin,
  textExpressionURL,
  handleSwitchTextExpressionElementShow
}) => {
  const videoTalkRef = useRef(null);
  const videoIdleRef = useRef(null);
  const videoTextExpressionRef = useRef(null);
  const isSpecialOrigin = origin === "classroom" || origin === "hospital";
  const chromaProps = isSpecialOrigin
    ? { chromaColor: { r: 0, g: 255, b: 0 }, sensitivity: { r: 100, g: 140, b: 100 } }
    : {};

  return (
    <div className="avatar">
      <div className="avatar-container">
      <video
          ref={videoTalkRef}
          src={videoURL}
          autoPlay={true}
          playsInline
          loop={true}
          muted={true}
          crossOrigin=""
          className={`avatar-canvas ${videoElementShow ? "show" : "hide"}`}
        />
      </div>

      <div className="avatar-container idle">
      <video
        ref={videoIdleRef}
        src={idleURL}
        autoPlay={true}
        playsInline
        loop={true}
        muted={true}
        crossOrigin=""
        className={`avatar-canvas ${canvasElementShow ? "show" : "hide"}`}
      />
      </div>
      <div className="avatar-container text-expression">
      <video
        ref={videoTextExpressionRef}
        src={textExpressionURL}
        autoPlay={true}
        playsInline
        loop={false}
        muted={false}
        crossOrigin=""
        onEnded={() => handleSwitchTextExpressionElementShow()}
        className={`avatar-canvas ${textExpressionElementShow ? "show" : "hide"}`}
      />
      </div>
      <div className="overlay"></div>
    </div>
   
  );
};

export default Avatar;
